import { render } from "./WalletTabs.vue?vue&type=template&id=c8e86500"
import script from "./WalletTabs.vue?vue&type=script&lang=js"
export * from "./WalletTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__